import {styled} from '@esgi/ui/theme';
import {Box} from '@esgi/ui/layout';

export const SelectTitleWrapper = styled(Box, {
	padding: '8px 12px',
	width: '100%',
	background: '$surface',
});
